import { Button } from '@/components/ui/button';
import { UpdateIcon } from '@radix-ui/react-icons';
import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableFooter,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import PATH_PAGE from '@/router/path';
import { Link, useParams } from 'react-router-dom';
import { fCurrencyUSDExtended } from '@/utils/formatNumber';
import { shortEnglishHumanizer } from '@/utils/formatTime';
import { Badge } from '@/components/ui/badge';
import { useGetUsageAndCostDedicateInstance } from '@/service/one-click-deploy/hook';
import { RouteParams } from '@/router/type';

const OneClickDeployDetailUsage = () => {
  const { instanceId } = useParams<RouteParams>();
  const { data, refetch } = useGetUsageAndCostDedicateInstance({
    instance_id: instanceId!,
  });
  const mock = [
    {
      computeTime: 16220021,
      pricing: 0.5,
      cost: 20.52,
    },
    {
      computeTime: 162200000,
      pricing: 0.6,
      cost: 1200,
    },
  ];
  const result = data?.items?.map((item) => ({
    computeTime: item.compute_time * 1000 * 60,
    pricing: item.price,
    cost: item.amount,
  }));

  const totalCost = data?.sum_price ?? 0;

  return (
    <>
      <p className="text-base font-semibold">Usage & Cost</p>
      <div className="mt-6">
        <Button
          variant={'secondary'}
          startIcon={<UpdateIcon />}
          onClick={() => refetch({})}
        >
          Refresh
        </Button>
      </div>
      <div className="mt-6">
        <Table>
          <TableCaption>
            To check past payment and all other billing, please go to your{' '}
            <Link to={PATH_PAGE.setting.payment} className="underline">
              payment.
            </Link>
          </TableCaption>
          <TableHeader>
            <TableRow>
              <TableHead className="w-[100px]">Order</TableHead>
              <TableHead>Compute Time</TableHead>
              <TableHead>Pricing (USD/hour)</TableHead>
              <TableHead className="text-right">Amount</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {result?.map((item, index) => (
              <TableRow key={index}>
                <TableCell>
                  {index + 1}{' '}
                  {index === result?.length - 1 && (
                    <Badge variant={'secondary'}>Active</Badge>
                  )}
                </TableCell>
                <TableCell>
                  {shortEnglishHumanizer(item.computeTime, {
                    units: ['h', 'm'],
                    delimiter: ' ',
                    maxDecimalPoints: 0,
                  })}
                </TableCell>
                <TableCell>{fCurrencyUSDExtended(item.pricing)}</TableCell>
                <TableCell className="text-right">
                  {fCurrencyUSDExtended(item.cost)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TableCell colSpan={3}>Total</TableCell>
              <TableCell className="text-right">
                {fCurrencyUSDExtended(totalCost)}
              </TableCell>
            </TableRow>
          </TableFooter>
        </Table>
      </div>
    </>
  );
};

export default OneClickDeployDetailUsage;
